export const scene = {
    "version": 2,
    "scenes": [
        {
            "id": "dcae38ea-89be-4236-824a-f9ef1d05d76d",
            "name": "Pronstorfer Krug - scene 1",
            "publicName": "Pronstorfer Krug",
            "startPositionX": null,
            "startPositionY": null,
            "background": {
                "type": "image",
                "mediumPath": "./textures/scene1.jpg",
                "sliceImage": true,
                "rotationY": 144
            },
            "objects": [
                {
                    "id": "aa9b9c8b-7124-46c6-acf7-93a2b6a8daea",
                    "type": "sceneChange",
                    "name": "Szenenwechsel 1",
                    "x": 284.78814832887537,
                    "y": -33.70282917987348,
                    "z": -288.1240189350064,
                    "scale": .8,
                    "goToSceneId": "6de74ecd-3b4e-4341-99ac-0f1de77098e7",
                    "transition": "rotateAndFlow"
                },
                {
                    "id": "aa9b9c8b-7124-46c6-acf7-93a2b6a8gaea",
                    "type": "sceneChange",
                    "name": "Szenenwechsel 2",
                    "x": 57.26223834267354,
                    "y": 1.0761354607867644,
                    "z": 465.30962738450245,
                    "scale": .8,
                    "goToSceneId": "6de74ecd-3b4e-4341-22ac-0f1de77095g1",
                    "transition": "rotateAndFlow"
                },
                {
                    "id": "1d133e14-9626-4bda-9ba1-c83112ed741c",
                    "type": "guestSeat",
                    "name": "Gast Sitzplatz 1",
                    "x": 195.90679247921003,
                    "y": -72.48078711475145,
                    "z": 215.33012831402343,
                    "scale": 1,
                    "profile": {
                        "avatar": "fox_avatar.png",
                        "name": "The Fox"
                    }
                },
                {
                    "id": "1d133e14-9626-4bda-9ba1-c83112ed985a",
                    "type": "guestSeat",
                    "name": "Gast Sitzplatz 2",
                    "x": -254.59402680934923,
                    "y": -80.32827979895261,
                    "z": 136.85484637944518,
                    "scale": 1,
                    "profile": {
                        "avatar": "bear_avatar.png",
                        "name": "The Bear"
                    }
                },
                {
                    "id": "1d133e14-9626-4bda-9ba5-c83112ed985a",
                    "type": "guestSeat",
                    "name": "Gast Sitzplatz 3",
                    "x": -246.26713370600376,
                    "y": -89.59031831014023,
                    "z": -146.03449497059586,
                    "scale": 1,
                    "profile": {}
                }
            ],
            "ambientAudio": {
                "type": "audio"
            },
            "introAudio": {
                "type": "audio"
            },
            "sceneRotationY": 1.7802358370342162,
            "backgroundRotationX": 0,
            "backgroundRotationY": "160",
            "backgroundRotationZ": 0,
            "autorotateAfterSeconds": 0,
            "autorotateSpeed": 0.1,
            "actionIfBackgroundVideoEnds": "stop",
            "goToSceneIdAfterBackgroundVideoEnds": "",
            "weather": null
        },
        {
            "id": "6de74ecd-3b4e-4341-99ac-0f1de77098e7",
            "name": "Pronstorfer Krug - scene 2",
            "publicName": "Pronstorfer Krug",
            "startPositionX": null,
            "startPositionY": null,
            "background": {
                "type": "image",
                "mediumPath": "./textures/scene2.jpg",
                "sliceImage": true,
                "rotationY": 155
            },
            "objects": [
                {
                    "id": "e14hab96-c8ac-495f-b12d-74171dbee921",
                    "type": "sceneChange",
                    "name": "Szenenwechsel 1",
                    "x": -155.65445701616474,
                    "y": -53.996177743209266,
                    "z": 286.2720744549951,
                    "scale": .8,
                    "goToSceneId": "dcae38ea-89be-4236-824a-f9ef1d05d76d",
                    "transition": "rotateAndFlow"
                }
            ],
            "ambientAudio": {
                "type": "audio"
            },
            "introAudio": {
                "type": "audio"
            },
            "sceneRotationY": 2.7576202181510405,
            "backgroundRotationX": 0,
            "backgroundRotationY": "205",
            "backgroundRotationZ": 0,
            "autorotateAfterSeconds": 0,
            "autorotateSpeed": 0.1,
            "actionIfBackgroundVideoEnds": "stop",
            "goToSceneIdAfterBackgroundVideoEnds": "",
            "weather": null
        },
        {
            "id": "6de74ecd-3b4e-4341-22ac-0f1de77095g1",
            "name": "Pronstorfer Krug - scene 3",
            "publicName": "Pronstorfer Krug",
            "startPositionX": null,
            "startPositionY": null,
            "background": {
                "type": "image",
                "mediumPath": "./textures/scene3.jpg",
                "sliceImage": true,
                "rotationY": 230
            },
            "objects": [
                {
                    "id": "e145aaaa-c8ac-495f-b12d-74171dbee921",
                    "type": "sceneChange",
                    "name": "Szenenwechsel 1",
                    "x": 309.77143982500945,
                    "y": -14.595338410015225,
                    "z": -205.87923770863918,
                    "scale": .8,
                    "goToSceneId": "dcae38ea-89be-4236-824a-f9ef1d05d76d",
                    "transition": "rotateAndFlow"
                }
            ],
            "ambientAudio": {
                "type": "audio"
            },
            "introAudio": {
                "type": "audio"
            },
            "sceneRotationY": 2.8448866807507573,
            "backgroundRotationX": 0,
            "backgroundRotationY": "205",
            "backgroundRotationZ": 0,
            "autorotateAfterSeconds": 0,
            "autorotateSpeed": 0.1,
            "actionIfBackgroundVideoEnds": "stop",
            "goToSceneIdAfterBackgroundVideoEnds": "",
            "weather": null
        }
    ],
    "rules": {
        "visibleIf": {},
        "hiddenIf": {}
    },
    "copyrightLogo": {},
    "previewBackgroundImage": {
        "type": "image",
        "mediumPath": "./textures/scene1.jpg",
        "transparent": false
    },
    "socialMediaPreviewImage": {},
    "worldAmbientAudio": {},
    "customIcons": {},
    "elementTypeIconAssignments": {},
    "name": "Nogersund",
    "description": "AAAA",
    "creatorUserIdOfWorld": "2",
    "publicAvailable": 1
}



export const users = [
    {
        "userId": "2",
        "userName": "vlado",
        "userAvatarUrl": "http://localhost:8921/img/avatar1.png",
        "currentSceneId": null,
        "currentSceneName": null,
        "currentUserMood": 1
    },
    {
        "userId": "eqm31n_qL5bCcvukURHnDxL2J2jwIXNx",
        "userName": "Etrigan",
        "userAvatarUrl": "http://localhost:8921/img/avatar3.png",
        "currentSceneId": null,
        "currentSceneName": null,
        "currentUserMood": 1
    }
]


export const friendList = [
    { userId: "75", name: "bojan", last: "ratkovic", nick: "3ojan" },
    { userId: "76", name: "znojan", last: "rac", nick: "Znojan" },
]